<template>
  <div>
    <v-row class="no-gutters" v-if="!mailSent && !passwordChanged">
      <div class="form-container">
        <div
          class="animate__animated"
          :class="{ animate__fadeIn: !mailSent && !passwordChanged }"
        >
          <div class="show-on-mobile text-center">
            <div class="animate__animated animate__zoomInDown">
              <div class="d-flex justify-center">
                <img
                  width="260"
                  class="cursor-pointer pb-8"
                  @click="$router.push('/')"
                  alt="Good Casper logo"
                  :src="require(`../assets/images/logo/good_casper_black.svg`)"
                />
              </div>
              <h2 class="title-4 primary--text mb-2 mt-12 pt-8">
                {{
                  $route.params.guid
                    ? lang.forgotPassword.createPassword
                    : lang.forgotPassword.forgotPassword
                }}
              </h2>
              <p
                class="p-subtitle primary--text"
                v-if="$route.params.guid"
                v-html="lang.forgotPassword.w4"
              ></p>
              <p
                class="p-subtitle primary--text"
                v-else
                v-html="lang.forgotPassword.w5"
              ></p>
            </div>
          </div>
          <v-row class="no-gutters mt-8">
            <v-col class="col-12">
              <v-form
                ref="formForgotPassword"
                @submit.prevent="submitForgotPassword"
              >
                <v-card
                  max-width="400"
                  class="mb-12 mt-0 mx-auto bg-transparent"
                  elevation="0"
                >
                  <div class="d-flex justify-center">
                    <img
                      width="260"
                      class="cursor-pointer mb-12 pb-2 hide-on-mobile"
                      @click="$router.push('/')"
                      alt="Good Casper logo"
                      :src="
                        require(`../assets/images/logo/good_casper_black.svg`)
                      "
                    />
                  </div>
                  <v-card-text>
                    <v-text-field
                      v-if="!$route.params.guid"
                      v-model="forgotPassword.username"
                      :rules="[rules.required, rules.email]"
                      :label="lang.fields.mail"
                      @keyup.enter="submitForgotPassword"
                    ></v-text-field>
                    <v-text-field
                      type="password"
                      v-if="$route.params.guid"
                      v-model="forgotPasswordConfirmation.password"
                      :rules="[rules.required]"
                      :label="lang.fields.newPassword"
                      @keyup.enter="submitForgotPassword"
                    ></v-text-field>
                    <v-text-field
                      type="password"
                      v-if="$route.params.guid"
                      v-model="forgotPasswordConfirmation.confirmPassword"
                      :rules="[rules.required, passwordRules.passwordMatch]"
                      :label="lang.fields.confirmPassword"
                      @keyup.enter="submitForgotPassword"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      v-if="$route.params.guid"
                      elevation="0"
                      class="mb-2 with-radius btn-bg"
                      block
                      x-large
                      @click="submitForgotPassword()"
                      >{{ lang.actions.save }}</v-btn
                    >
                    <v-btn
                      v-else
                      elevation="0"
                      class="mb-2 with-radius btn-bg"
                      block
                      x-large
                      @click="submitForgotPassword()"
                      >{{ lang.actions.send }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="text-container">
        <div class="animate__animated animate__zoomInDown">
          <!-- <div class="d-flex justify-center mb-12 pb-10">
                  <img
                    width="260"
                    class="cursor-pointer mb-6"
                    @click="$router.push('/')"
                    alt="Good Casper logo"
                    :src="require(`../assets/images/logo/good_casper_white.svg`)"
                  />
                </div> -->
          <h2 class="title-4">
            {{
              $route.params.guid
                ? lang.forgotPassword.createPassword
                : lang.forgotPassword.forgotPassword
            }}
          </h2>
          <p
            class="p-subtitle"
            v-if="$route.params.guid"
            v-html="lang.forgotPassword.w4"
          ></p>
          <p class="p-subtitle" v-else v-html="lang.forgotPassword.w5"></p>
          <p class="white--text my-3 font-weight-bold">
            {{ lang.login.or }}
          </p>
          <v-btn x-large outlined class="with-radius" to="/Login?state=login">{{
            lang.actions.login
          }}</v-btn>
        </div>
      </div>
    </v-row>
    <div v-else class="text-container text-container-full">
      <div class="d-flex justify-center">
        <img
          width="260"
          class="cursor-pointer pb-8"
          @click="$router.push('/')"
          alt="Good Casper logo"
          :src="require(`../assets/images/logo/good_casper_white.svg`)"
        />
      </div>
      <div
        v-if="mailSent"
        class="animate__animated"
        :class="{ animate__zoomInDown: mailSent }"
      >
        <h2 class="title-2">
          {{ lang.forgotPassword.w1 }}
        </h2>
        <p class="p-subtitle">{{ lang.forgotPassword.w11 }}</p>
        <v-btn x-large outlined class="with-radius" to="/Login?state=login">{{
          lang.forgotPassword.w3
        }}</v-btn>
      </div>
      <div
        v-if="passwordChanged"
        class="animate__animated"
        :class="{ animate__zoomInDown: passwordChanged }"
      >
        <h2 class="title-2">
          {{ lang.forgotPassword.w2 }}
        </h2>
        <p class="p-subtitle">{{ lang.forgotPassword.w22 }}</p>
        <v-btn x-large outlined class="with-radius" to="/Login?state=login">{{
          lang.forgotPassword.w3
        }}</v-btn>
      </div>
    </div>
    <div
      v-if="mailSent || passwordChanged"
      class="show-on-mobile text-container-full"
    >
      <div class="d-flex justify-center">
        <img
          width="260"
          class="cursor-pointer mb-12 pb-2"
          @click="$router.push('/')"
          alt="Good Casper logo"
          :src="require(`../assets/images/logo/good_casper_black.svg`)"
        />
      </div>
      <div
        v-if="mailSent"
        class="animate__animated text-center"
        :class="{ animate__zoomInDown: mailSent }"
      >
        <h2 class="title-2 primary--text">
          {{ lang.forgotPassword.w1 }}
        </h2>
        <p class="p-subtitle primary--text">{{ lang.forgotPassword.w11 }}</p>
      </div>
      <div
        v-if="passwordChanged"
        class="animate__animated text-center"
        :class="{ animate__zoomInDown: passwordChanged }"
      >
        <div class="d-flex justify-center">
          <img
            width="260"
            class="cursor-pointer pb-8"
            @click="$router.push('/')"
            alt="Good Casper logo"
            :src="require(`../assets/images/logo/good_casper_white.svg`)"
          />
        </div>
        <h2 class="title-2 primary--text">
          {{ lang.forgotPassword.w2 }}
        </h2>
        <p class="p-subtitle primary--text">{{ lang.forgotPassword.w22 }}</p>
        <v-btn
          x-large
          outlined
          class="with-radius primary--text"
          to="/Login?state=login"
          >{{ lang.forgotPassword.w3 }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ForgotPassword",
  data() {
    return {
      mailSent: false,
      passwordChanged: false,
      passwordRules: {
        passwordMatch: () =>
          this.forgotPasswordConfirmation.password ===
            this.forgotPasswordConfirmation.confirmPassword ||
          this.lang.rules.passwordMustMatch,
      },
    };
  },
  computed: {
    ...mapGetters(["rules", "forgotPassword", "forgotPasswordConfirmation"]),
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  mounted() {
    document.title = "Good Casper - Forgot Password";
    this.$store.dispatch("user/logout");
  },
  methods: {
    submitForgotPassword() {
      var thisy = this;
      if (this.$refs.formForgotPassword.validate()) {
        if (this.$route.params.guid) {
          this.$store
            .dispatch("user/forgotPassword", {
              guid: this.$route.params.guid,
              password: this.forgotPasswordConfirmation.password,
            })
            .then(() => {
              thisy.passwordChanged = true;
            });
        } else {
          this.$store
            .dispatch("user/forgotPasswordMail", this.forgotPassword.username)
            .then(() => {
              thisy.mailSent = true;
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hide-on-mobile {
  display: block;
  @media only screen and (max-width: 1050px) {
    display: none;
  }
}
.forgot-password-link {
  text-decoration: none;
}
.text-container-full {
  width: 100% !important;
  padding: 0 10px;
}

@media only screen and (max-width: 1050px) {
  .text-container-full {
    margin-top: 80px;
  }
}
</style>